import { useEffect, useState } from "react";
import { IFilterInput, IFilterOutput } from "@types";

function useFilters(action: (data: IFilterOutput[]) => void, defaultFilters?: IFilterOutput[]) {
  const [filters, setFilters] = useState<IFilterOutput[]>([]);
  useEffect(() => {
    if (defaultFilters) {
      setFilters([...defaultFilters]);
    } else {
      setFilters([]);
    }
  }, [defaultFilters]);

  const handelFilters = (data: IFilterInput, item: number) => {
    const _filters = [...filters];
    const target = _filters.find((f) => f.id === data.id);
    const _target = _filters.filter((f) => f.id !== data.id);

    if (target) {
      updateFilter(data, item, target, _target);
    } else {
      setFilters([
        ..._filters,
        {
          key: data.key,
          type: data.type,
          id: data.id,
          operation_type: data.operation_type,
          items: [item],
          items_operation: data.items_operation,
        },
      ]);
    }
  };

  const updateFilter = (
    data: IFilterInput,
    item: number,
    target: IFilterOutput,
    _target: IFilterOutput[]
  ) => {
    if (data.type === "singleSelect") {
      const newFilter = target.items?.includes(item)
        ? _target
        : [..._target, { ...target, items: [item] }];
      setFilters(newFilter);
    } else if (data.type === "multiSelect") {
      if (target.items?.includes(item)) {
        const index = target.items.indexOf(item);
        target.items.splice(index, 1);
        const newFilter = target.items.length ? [..._target, { ...target }] : _target;
        setFilters(newFilter);
      } else {
        target.items?.push(item);
        setFilters([..._target, { ...target }]);
      }
    }
  };

  const handelRangeFilter = (data: IFilterInput, range: number[]) => {
    const _filters = [...filters];
    const target = _filters.find((f) => f.key === data.key);
    const _target = _filters.filter((f) => f.key !== data.key);
    if (target) {
      target.range = { min: range[0], max: range[1] };

      setFilters([..._target, { ...target }]);
    } else {
      setFilters([
        ..._filters,
        {
          key: data.key,
          type: data.type,
          id: data.id,
          operation_type: data.operation_type,
          range: { min: range[0], max: range[1] },
          items_operation: data.items_operation,
        },
      ]);
    }
  };

  const resetAll = () => {
    setFilters([]);
    action([]);
  };

  const handelSubmitFilters = () => {
    const finalFilter = [];
    for (const iterator of filters) {
      let data = { ...iterator };
      delete data.id;
      finalFilter.push(data);
    }
    action(finalFilter);
  };

  return {
    filters,
    setFilters,
    handelSubmitFilters,
    resetAll,
    handelRangeFilter,
    handelFilters,
  };
}

export default useFilters;
